import React from 'react';
import Button from '@ali/infinite-webui/es/web-components/Button';
import ITAndC from '../T&C/index-pc';
import SubscribePopup, { POPUP_TYPE } from '../../index-pc';
import { statusCode as statusCodeEnum, IUserTrack } from '../../const';
import { cls } from '../../utils';
import Styles from './index-pc.module.scss';

export default function FooterBtn({
  closeBtnText,
  btnText,
  tc,
  btnClick,
  statusCode = statusCodeEnum.default,
  statusClick,
  howToUse,
  type,
  userTrack = {},
}: IFooterBtn) {
  return (
    <div className={Styles.footer}>
      <ITAndC tc={tc} />
      <div
        className={cls([
          Styles.footerBtn,
          type === POPUP_TYPE.PROMOTION_IMAGE && Styles.footerImageBtn,
        ])}
      >
        {statusCode === statusCodeEnum.default && (
          <>
            {closeBtnText && (
              <Button
                className="auto-evt"
                data-spm={
                  type === POPUP_TYPE.NU_VOUCHER ? 'dNBV_Close' : 'dCancel'
                }
                data-params-exp={JSON.stringify(userTrack.exposeArgs)}
                data-params-clk={JSON.stringify(userTrack.clickArgs)}
                type="secondary"
                size="large"
                onClick={() => {
                  SubscribePopup.close();
                }}
              >
                {closeBtnText}
              </Button>
            )}
            {btnText && (
              <Button
                className="auto-evt"
                data-spm={type === POPUP_TYPE.NU_VOUCHER ? 'dNBV_CTA' : 'dCTA'}
                type="primary"
                size="large"
                data-params-exp={JSON.stringify(userTrack.exposeArgs)}
                data-params-clk={JSON.stringify(userTrack.clickArgs)}
                onClick={() => {
                  btnClick();
                }}
              >
                {btnText}
              </Button>
            )}
          </>
        )}

        {[statusCodeEnum.collectResult, statusCodeEnum.collected].indexOf(
          statusCode
        ) > -1 && (
          <div
            className={cls([Styles.footerSuccessTxt, 'auto-evt'])}
            data-spm={`dNBV_tutorial`}
            data-params-exp={JSON.stringify(userTrack.exposeArgs)}
            data-params-clk={JSON.stringify(userTrack.clickArgs)}
            onClick={statusClick}
          >
            {howToUse}
          </div>
        )}
      </div>
    </div>
  );
}

interface IFooterBtn {
  btnText: string;
  closeBtnText: string;
  tc: string;
  btnClick?: () => void;
  statusClick?: () => void;
  type?: string;
  statusCode?: string;
  howToUse?: string;
  userTrack: IUserTrack
}
